export default {
    //ChangeSubscriptionComponent
    info_promotional_coupon: '¿Tienes un cupón promocional? Haz click en "Activar" para usarlo. ',

    //CurrentSubscriptionComponent
    canceled_message: 'Su cuenta ha sido cancelada. Suscríbase a un plan para volver a activar su cuenta.',

    //StripeNumberComponent
    change_pay_method: 'Cambiar método de pago',

    //NavigationMyAccountComponent e InformationComponent
    subtitle: "Manage your profile, billing and your academy's subscription.",
    sections: 'My account sections',
    profile_description: 'Personal details, photo and password',
    billing_details: 'Billing details',
    billing_details_description: 'Tax details and bank account',
    my_subscription: 'My subscription',
    my_subscription_description: 'Current plan and invoices',
    plans_description: 'Change or reactivate your plan',
    my_academies: 'My academies',
    my_academies_description: 'Academies in your account',
    about: 'About',
    about_description: 'Version and release notes',
    about_title: 'Application information',
    app_name: 'Application',
    manufacturer: 'Manufacturer',
    version: 'Version',
    changelog: 'Release notes',
    current_version: 'Current version',
    show_less: 'Show less',
    show_full_history: 'Show full history ({count} more)',
    thanks: 'Thank you for trusting BrainsPro. We keep improving the platform and you can check the latest updates here as we release them.',
}
